import Card from "../card/Card";

export default function CardGroup({ label, cards, selectedBilling, onBillingToggle, hideButtons = false, currentPlan = null }) {
  const cardCount = cards.length;

  // Dynamically generate grid classes based on the number of cards
  const getGridCols = () => {
    if (cardCount === 1) return "grid-cols-1";
    if (cardCount === 2) return "md:grid-cols-2";
    if (cardCount === 3) return "md:grid-cols-2 xl:grid-cols-3";
    if (cardCount >= 4) return "md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4";
    return "grid-cols-1";
  };

  return (
    <div className="p-8 md:py-28 md:px-20 mx-auto max-w-[1500px]">
      <label className="flex justify-center text-custom-blue font-bold text-2xl md:text-4xl my-4 text-center">
        {label}
      </label>
      <div
        className={`grid grid-cols-1 ${getGridCols()} bg-custom-gray gap-8 my-5`}
      >
        {cards.map((item, index) => (
          <Card
            key={index}
            title={item?.title}
            description={item?.description}
            buttonText={item?.buttonText}
            features={item?.features?.filter(feature => feature.value !== "false").map((feature) => feature.value === "true" ? feature.text : feature.text + "(" + feature.value +")")}
            price={item?.price}
            yearlyPrice={item?.yearlyPrice}
            specialOffer={item?.specialOffer}
            selectedBilling={selectedBilling}
            onBillingToggle={onBillingToggle}
            hideButtons={hideButtons}
            currentPlan={currentPlan}
            planType={item?.type}
          />
        ))}
      </div>
    </div>
  );
}
